import { DataContainer } from './components/DataContainer';
import { useEffect, useState } from 'react';
import { default as FNS } from './api';
import { useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getBrand } from './brands';



const STATE_LOADING = 0;
const STATE_SUCCESS = 1;
const STATE_ALREADY_SUBMITTED = 2;
const STATE_IDLE = 3;

function RejectResponse() {
    const [ state, setState ] = useState(STATE_IDLE);
    const [ reason, setReason ] = useState(null);
    const [ brand, setBrand ] = useState(getBrand(null));
    const [searchParams] = useSearchParams();

    const id = searchParams.get('id');
    const activation_key = searchParams.get('activation_key');

    console.log(id, activation_key);

    useEffect(() => {
        async function checkAlreadySubmitted() {
            setState(STATE_LOADING);
            try {
                const response = await FNS.emailCheckResponse(id, activation_key);
                setState(response.alreadyAnswered ? STATE_ALREADY_SUBMITTED : STATE_IDLE);
                setReason(response.answer || null);
                setBrand(getBrand(response.query_brand));
            } catch (error) {
                console.error(error);
                toast.error("An error occurred while checking the response status.");
                setState(STATE_IDLE);
            }
        }

        checkAlreadySubmitted();
    }, [id, activation_key]);

    async function submit() {
        setState(STATE_LOADING);
        const { alreadyAnswered } = await FNS.emailRejectResponse(id, activation_key, reason);
        setState(alreadyAnswered ? STATE_ALREADY_SUBMITTED : STATE_SUCCESS);
        if(!alreadyAnswered) toast.success("Tagasiside edastatud");
    }

    switch(state) {
        case STATE_LOADING: return (

            <DataContainer forceLoading={true} >
                <div style={{ width: '100%', minHeight: '100vh' }}></div>
            </DataContainer>

        );
        case STATE_IDLE: return (

            <div className="width100 g32 p32 column center-main center-cross" style={{ height: '100vh' }}>
                <div className="column">
                    <h1>Pakkumise tagasi lükkamine</h1>
                    <p>Miks otsustasite pakkumise tagasi lükata?</p>
                </div>

                <div className="column g32">

                    <div className="column g8">
                        <label>
                            <input checked={reason === "cheaper_elsewhere"} type="radio" value="cheaper_elsewhere" onChange={(e) => setReason(e.target.value)} />
                            Sain soodsama pakkumise
                        </label>
                        <label>
                            <input checked={reason === "over_budget"} type="radio" value="over_budget" onChange={(e) => setReason(e.target.value)} />
                            Pakkumine ületab eelarvet
                        </label>
                        <label>
                            <input checked={reason === "trip_cancelled"} type="radio" value="trip_cancelled" onChange={(e) => setReason(e.target.value)} />
                            Reis jääb ära
                        </label>
                        <label>
                            <input checked={reason === "other"} type="radio" value="other" onChange={(e) => setReason(e.target.value)} />
                            Pakkumine ei sobi muul põhjusel
                        </label>
                    </div>

                    <button onClick={submit}>Edasta</button>
                </div>
            </div>

        );
        case STATE_SUCCESS: return (

            <div className="width100 g32 p32 column center-main center-cross" style={{ height: '100vh' }}>
                <h1 className="title">Täname!</h1>
                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_604_139)"><circle cx="32" cy="32" r="32" fill="#65D190"/><path d="M9.37259 32.0001L15.0294 26.3432L26.3432 37.6569L48.9706 15.0295L54.6274 20.6864L26.3432 48.9707L9.37259 32.0001Z" fill="white"/></g><defs><clipPath id="clip0_604_139"><rect width="64" height="64" fill="white"/></clipPath></defs></svg>
                <p style={{ textAlign: 'center' }}>Vastus on vastuvõetud. Aitäh tagasiside eest!</p>
                <a href={brand.siteUrl} style={{ backgroundColor: '#aaf', borderRadius: 4, padding: 8, color: '#fff' }}>Avalehele</a>
            </div>

        );
        case STATE_ALREADY_SUBMITTED: return (
            <div className="width100 g32 p32 column center-main center-cross" style={{ height: '100vh' }}>
                <h1 className="title">Reisist keeldumine</h1>
                <svg width="64" height="64" xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none"><g clip-path="url(#clip0_1021_179)"><circle cx="32" cy="32" r="32" fill="#D16565"/><path fill-rule="evenodd" clip-rule="evenodd" d="M48.9706 20.6864L43.3137 15.0295L32 26.3432L20.6863 15.0295L15.0294 20.6864L26.3431 32.0001L15.0294 43.3138L20.6863 48.9707L32 37.6569L43.3137 48.9707L48.9706 43.3138L37.6569 32.0001L48.9706 20.6864Z" fill="white"/></g><defs><clipPath id="clip0_1021_179"><rect width="64" height="64" fill="white"/></clipPath></defs></svg>
                {reason === "rejected" ? (
                    <p style={{ textAlign: 'center' }}>Olete juba reisi tühistanud. Kui soovite reisi ikkagi kinnitada, siis võtke meiega ühendust.</p>
                ) : (
                    <p style={{ textAlign: 'center' }}>Olete juba reisi kinnitanud. Kui soovite reisi tühistada võtke meiega ühendust.</p>
                )}
                <p>{brand.contactEmail}</p>
                <a href={brand.siteUrl} style={{ backgroundColor: '#aaf', borderRadius: 4, padding: 8, color: '#fff' }}>Avalehele</a>
            </div>

        );
        default: return null;
    }
}

export default RejectResponse;